import {Directive} from "@angular/core";
import { NgModel } from "@angular/forms";

@Directive({
  selector: '[ngModel][nullValue]',
  providers: [NgModel],
  host: {
    '(ngModelChange)' : 'onInputChange($event)'
  }
})
export class NullDefaultValueDirective{
  constructor(private model:NgModel){}

  onInputChange(event){
    this.model.valueAccessor.writeValue(event === null ? '' : event);
  }
}
